// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"684":"4c6359a2","745":"f209a52a","814":"222b523c","906":"6ce14917","922":"eeed99b1","940":"c5f5a2d5"}[chunkId] + ".css";
};